import React, { useState } from "react";
import { Link } from "react-router-dom";
import Auth from "services/Auth";

import "./sidenav.sass";

function SideNav(props) {
  const [navOn, setNavOn] = useState(false);

  const toggleNav = () => {
    setNavOn(!navOn);
  };
  const closeNav = () => {
    setNavOn(false);
  };
  const navClass = navOn ? "open" : "closed";

  return (
    <nav className={navClass}>
      <ul className="list-group list-group-flush" onClick={closeNav}>
        <Link to="/shows" className="list-group-item list-group-item-action">
          Выставки
        </Link>
        <Link to="/dogs" className="list-group-item list-group-item-action">
          Собаки
        </Link>
        <Link to="/breeds" className="list-group-item list-group-item-action">
          Породы
        </Link>
        <Link to="/experts" className="list-group-item list-group-item-action">
          Эксперты
        </Link>
        <div>&nbsp;</div>
        <Link to="/registration-requests" className="list-group-item list-group-item-action">
          Заявки на выставку
        </Link>
        <div>&nbsp;</div>
        <Link to="/users" className="list-group-item list-group-item-action">
          Пользователи
        </Link>
        <Link to="/printers" className="list-group-item list-group-item-action">
          Принтеры
        </Link>
        <button onClick={Auth.signout} className="text-danger list-group-item list-group-item-action">
          Выйти
        </button>
      </ul>
      <button onClick={toggleNav} className="btn-open-nav">
        {navOn ? "<" : ">"}
      </button>
    </nav>
  );
}

export default SideNav;
